const hjId = '5088406';

declare const __STAGE__: string;
const isProd = __STAGE__ === 'production';

try {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  (window as Window)._hjSettings = {
    hjid: hjId,
    hjsv: 6,
  };

  // if production env load the hotjar script on app load
  if (isProd) {
    const script = document.createElement('script');
    script.src = `https://static.hotjar.com/c/hotjar-${hjId}.js?sv=6`;

    document.head.appendChild(script);
  }
} catch (error) {
  //ignore
}

export {};
